<!--
<div style="display:flex;justify-content:space-between;margin-bottom:0.5rem;margin-top:0.5rem;"
     *ngIf="!easyToRead">
    <span style="font-weight:bold">{{ 'Selected determinants' | translate }}</span>
</div>
-->
<!--
<div class="row" *ngIf="!easyToRead && !readOnly">
    <div class="col-12">
        <div class="determinant-main-hint">{{'determinants.main_hint' | translate}}</div>
    </div>
</div>
-->
<div
    id="{{prefix}}-conditionsSelected"
     class="form-group m-0 builder-drop-area row no-gutters pt-3"
     *ngIf="!easyToRead"
     cdkDropList
    [cdkDropListData]="groups"
    (cdkDropListDropped)="dropped($event)">
    <div cdkDrag [cdkDragDisabled]="readOnly" class="list-table determinants-table {{(groups.length <= 1 && group.items.length === 0) ? 'col h-100 mh-100' : 'col-auto w-100'}}"
         *ngFor="let group of groups; let j=index;">
        <div *ngIf="j > 0"
             class="m-2">
            <and-or [selectedItem]="group.type"
                    [readonly]="readOnly"
                    (valueChanged)="groupAndOrTypeChanged($event, j)"></and-or>
        </div>

        <div class="d-flex flex-column {{(groups.length <= 1 && group.items.length === 0) ? 'h-100' : ''}}">
            <div class="item-mandatory d-flex flex-grow-1 flex-column {{(groups.length <= 1 && group.items.length === 0) ? 'empty-drop-zone' : ''}}"
                 cdkDropList
                 id="{{prefix}}-conditionsSelected-{{j}}"
                [cdkDropListConnectedTo]="createConnectedTo(j)"
                [cdkDropListData]="group.items"
                (cdkDropListDropped)="droppedItem($event, j)">
                <div cdkDrag
                     [cdkDragDisabled]="readOnly" class="d-flex align-items-baseline item-mandatory-item p-2"
                     *ngFor="let item of group.items; let i=index;">
                    <and-or [selectedItem]="item.type"
                            [readonly]="readOnly"
                            class="d-flex flex-shrink-1 mr-2 item-and-or"
                            (valueChanged)="conditionAndOrTypeChanged($event, j, i)"
                            *ngIf="i > 0"></and-or>
                    <span class="d-flex flex-shrink-1 mr-2 item-and-or"
                          *ngIf="i === 0"></span>
                    <div class="determinant-element-row d-flex flex-grow-1 pl-2 pr-0 py-2">
                        <span class="strong">{{determinantMapById && determinantMapById[item.determinantId] || findDeterminantName(item) }}</span>
                        <i *ngIf="!readOnly"
                           class="btn-xs btn-bordered btn-danger btn-icon fas fa-times"
                           (click)="removeItemFromGroup(item, group)"></i>
                    </div>
                </div>
                <div class="d-flex align-items-baseline mt-5"
                     *ngIf="group.items.length === 0">
                    <div class="determinant-element-row d-flex flex-column flex-grow-1 p-2 justify-content-center {{groups.length > 1 ? 'opacity-25' : ''}}">
                        <span class="text-muted m-0">{{noneSelectedSubText | translate}}</span>
                    </div>
                </div>
            </div>

            <div *ngIf="groups.length > 1 || group.items.length > 0" class="item-mandatory-actions d-flex flex-shrink-1 justify-content-end flex-row p-2">
                <i *ngIf="!readOnly && groups.length > 1"
                   class="fas fa-minus btn btn-xs btn-icon btn-default mr-2"
                   (click)="removeGroup(j)"></i>

                <i *ngIf="false"
                   class="fas fa-pencil-alt btn-xs btn-outline-primary btn-icon item-mandatory-action-update"></i>

                <i *ngIf="!readOnly && (groups.length > 1 || group.items.length > 0)"
                   class="fas fa-plus btn btn-xs btn-icon btn-default"
                   (click)="addNewBlockAfter(group)"></i>
            </div>
        </div>

    </div>
</div>

<div *ngIf="easyToRead && determinantMapById">
    <span *ngFor="let group of groups; let j=index;">
		<span *ngIf="j > 0" class="{{group.type=='AND' ? 'highlight-danger' : 'highlight-warning'}}">{{group.type}}</span>
    <span *ngFor="let item of group.items; let i=index; let last=last; let first=first">
			<span *ngIf="first && group.items.length > 1">( </span>
    <span *ngIf="i > 0"
          class="{{item.type=='AND' ? 'highlight-danger' : 'highlight-warning'}}">{{item.type}}</span>
    <span>{{determinantMapById && determinantMapById[item.determinantId] || findDeterminantName(item)}}</span>
    <span *ngIf="last && group.items.length > 1"> )</span>
    </span>
    <span *ngIf="group.items.length === 0"
          style="color: #999">{{noneSelectedText | translate}}</span>
    </span>
</div>
